export default "__VITE_ASSET__DzHhaslG__"